import { useEffect, useState } from 'react';
import { getCart } from '../api/commerce';
import { getUser, createOrder } from '../api/checkout';
import { createPaymentIntent } from "../api/payment";
import { getCredit } from '../api/credit';
import { useAuth } from '../utils/AuthContext';
import { useNavigate, useLocation, Link } from 'react-router-dom';
import { useParams } from "react-router-dom";
import Loading from '../components/loading/Loading';
import NavbarLog from '../components/NavbarLog';
import Footer from '../components/Footer';
import dayjs from "dayjs";
import utc from "dayjs/plugin/utc";
import jalaliday from "jalaliday";
import "dayjs/locale/fa";
import "../css/Checkout.css";


const CheckoutPage = () => {
  const [error, setError] = useState('');
  const [errorAdr, setErrorAdr] = useState('');
  const [consoleError, setConsoleError] = useState("");
  const [carts, setCarts] = useState([]);
  const [cartValue, setCartValue] = useState();
  const [message, setMessage] = useState("");
  const [infoCredit, setCredit] = useState(false);
  const [profile, setProf] = useState(false);
  const [updatedProfile, setUpdatedProf] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [setlang, setLang] = useState("fa")
  const { lang } = useParams();
  const { user, isAuthenticated, loading } = useAuth();
  const [items, setItems] = useState([]);
  const navigate = useNavigate();
  const location = useLocation();
  const [profInfo, setProfInfo] = useState([]);

  // User information

  const fetchUser = async () => {
    try {
      const res = await getUser();
      setProf(res);
      setUpdatedProf(res);
    } catch (error) {
      setConsoleError("Error loading user information:", error);
    } 
  };

  useEffect(() => {
    fetchUser();
  }, []);
  
  useEffect(() => {
    if (!loading) {
     if (!isAuthenticated) {
      navigate(`/${lang}/login`, { state: { from: location }, replace: true });
      } 
    }
    fetchUser();
  }, [ loading, navigate, location]);
  
  // Credit information
  const fetchCredit = async () => {
    try {
      const response = await getCredit();
      const creditData = Array.isArray(response) ? response[-0] : response.data[-0];
      setCredit(creditData);   
    } catch (error) {
      setConsoleError("Error loading cart:", error);
    } 
  };
  
  useEffect(() => {
    if (isAuthenticated) { 
    fetchCredit();
    }
  }, [isAuthenticated]); 
  
  // Cart information
  const fetchCart = async () => {
    try {
      const response = await getCart();
      const cartsData = Array.isArray(response) ? response : response.data;
      setCarts(cartsData);
      setCartValue(cartsData[0].total);
      setItems(cartsData[0].items)
      
    } catch (error) {
      setConsoleError("Error loading cart:", error);
    } 
  };
  
  useEffect(() => {
    if (isAuthenticated) {
      fetchCart();
    }
  }, [isAuthenticated]); 
  
  // Update temporary modal form data
  const handleChange = (e) => {
    const { name, value } = e.target;
    setUpdatedProf((prev) => ({ ...prev, [name]: value }));
  };

  // Submit: apply changes and close
  const handleSaveprofile = (e) => {
    e.preventDefault();
    setProf(updatedProfile);
    closeModal();
  };

  // Cancel: discard changes and close
  const handleCancel = () => {
    setProf(profile); 
    closeModal();
  };

  // Utilities
  const openModal = () => {
    setIsModalOpen(true);
  };

  const closeModal = () => {
    setIsModalOpen(false);
    setPayModal(false);
  };

  const handleOverlayClick = (e) => {
    if (e.target === e.currentTarget) {
      closeModal();
    }
  };

  
  // Transation
  dayjs.extend(utc);
  dayjs.extend(jalaliday);
  const toPersiDigits = (str) => 
    str
    .replace(/\d/g, (d) => "۰۱۲۳۴۵۶۷۸۹"[d])
    .replace(/\./g, '/');


  useEffect (() => {
    const userTimezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
    if(lang !== "fa" && lang !== "en") {
      if ( userTimezone === "Asia/Tehran") {
        setLang(`fa`);
      } else {
        setLang(`en`);
      }
    } else {
      setLang(lang)
    }
  }, [lang])


  // Purchase
  const [payModal, setPayModal] = useState(false);
  const [defiCred, setDefiCred] = useState();
  
  const handleOrdGen = async () => {
    try {
      if (!items.length) {
        setError(setlang === "en"?"Cart is empty.":"سبد خرید شما خالی است");
        return;
      }
      const orderPayload = {
        cart_number:carts[0].id,
        subtotal: carts[0].subtotal,
        total_amount: cartValue,
        items: carts[0].items.map((item) => ({
          product: item.product.id,
          price: item.product.price,
          quantity: 1,
          subtotal:item.subtotal,
          tax_amount:item.tax_amount,
          shipping_rate:item.shipping_rate,
          total:item.total,
          arrival_date:item.arrival_date,
          shipping_style:item.shipping_style,
          shipping_carrier:item.shipping_carrier,
        })),
        delivery: {
          first_name:updatedProfile.first_name,
          last_name:updatedProfile.last_name,
          email:updatedProfile.email,
          contact: updatedProfile.phone,
          address: updatedProfile.address,
          city: updatedProfile.city,
          province: updatedProfile.province,
          zipcode: updatedProfile.zipcode,
          country: updatedProfile.country,
        },
      };

      await createOrder(orderPayload);

      // Reset states
      setItems([]);
      setError("");
      alert(setlang === "en"?"Order created successfully.":"سفارش با موفقیت ارسال شد");
      navigate(`/${lang}/ordersuccess`);

    } catch (err) {
      setError(err.response?.data?.message || "Failed to create order");
      if (setlang === "en") {
        alert("Please ensure complete delivery information is provided")
        setErrorAdr("Please ensure complete delivery information")
      } else {
        alert("لطفا آدرس پستی را کامل وارد کنید")
        setErrorAdr("لطفا آدرس پستی را کامل وارد کنید")
      }
    }
  };

  const handlePurchase = async () => {
    try {
      const response = await getCart();
      const cartsData = Array.isArray(response) ? response[-0] : response.data[-0];
      const cartTotal = cartsData.total;
      const availCredit = infoCredit.amount_available_IRT;

      if (availCredit === null || cartTotal === null) {
        setPayModal(true);
        return;
      }

      if (Number(cartTotal) > Number(availCredit)) {
        setPayModal(true);
        setDefiCred(cartTotal-availCredit)

      } else {
        try {
          handleOrdGen();
        } catch (error) {
          setConsoleError("Error placing order:", error);
        }        
      }
    } catch (error) {
      setConsoleError("Error fetching data:", error);
    }
  };

  

  if (loading) return <Loading />;  
  return (
    <>
      <NavbarLog/>
      <div className='c-page'>
        <h1>{setlang === "en" ?  "Checkout" : "ثبت سفارش" }</h1>
        <p>{setlang === "en" ? "Verify order information" : "لطفا از درستی آدرس پستی اطمینان حاصل فرمایید" }</p>
        <main className="c-grid">
          <div className='c-prod-container-prods'> 
            <h2>{setlang === "en" ? "Order Information" : "آیتم‌های سفارش" }</h2>
            <div>
              {carts.map(cart => (
                <div key={cart.id}>
                  {(cart.items || []).length === 0 ? (
                    <div className="c-empty">{setlang === "en" ? "Your cart is empty." : "سبد خرید شما خالی می‌باشد"} </div>
                  ) : (
                    cart.items.map(item => (
                      <div className="c-card" key={item.id}>
                        <div className="c-imags">
                          {Array.isArray(item.product.images) && item.product.images.length > 0 &&
                            item.product.images.map(img => (
                                <img key={img.id}
                                  className="c-image"
                                  src={img.image}
                                  alt={img.id}
                                />
                            ))
                          }
                          {Array.isArray(item.product.images) && item.product.images.length == 0 &&
                          <p>{setlang === "en" ? "No images available" : "عکسی موجود نیست"}</p>
                          }
                        </div>
                        <div>
                          <h3 id={`product-${item.id}`}>
                            {item.product?.name ?? "Unnamed Product"}
                          </h3>
                          <p>
                            {item.product?.description
                              ? item.product.description.slice(0, 60)
                              : "''"}
                          </p>

                          {item.product?.artist && (
                            <p>{setlang === "en" ? "By:" : "اثر:" } {item.product.artist.slice(0, 60)}</p>
                          )}
                          {setlang === "en"? 
                          <div className="c-price">IRT {new Number(item.subtotal).toLocaleString()}</div>
                          :
                          <div className="c-price">{toPersiDigits(new Number(item.subtotal).toLocaleString())} تومان</div>
                          }
                        </div>
                      </div>
                    ))
                  )}
                </div>
              ))}
            </div>
          </div>
          
          <div className="c-summary">
            <div className="c-summary-card">
              <h2>{setlang === "en" ? "Payment Summary" : "ارزش سبد خرید" }</h2>
              {carts.map(cart => (
                <div key={cart.id}>

                  {setlang === "en" ?
                  <div className="summary-row">
                    <span>Subtotal</span>
                    <strong>IRT {new Number(cart.subtotal).toLocaleString()}</strong>
                  </div> :
                  <div className="summary-row">
                    <strong>{toPersiDigits(new Number(cart.subtotal).toLocaleString())}</strong>
                    <span>جمع سبد خرید (تومان)</span>
                  </div>
                  }

                  {(cart.items || []).length === 0 ? (
                    <div className="c-empty">{setlang === "en" ? "Your cart is empty." : "سبد خرید شما خالی می‌باشد"}</div>
                  ) : (
                    cart.items.map(item => (
                      <div key={item.id}>
                        <div className='c-minidivider'></div>
                          <div>{item.product.name}</div>
                        <div className="c-summary-row muted">
                          {setlang === "en" ? 
                          <span> <small>including 9.6% VAT (IRT {new Number(item.tax_amount).toLocaleString()})</small></span> :
                          <span> <small>شامل 9.6% مالیات بر ارزش افزوده ( {toPersiDigits(new Number(item.tax_amount).toLocaleString())} تومان)</small></span>
                          }
                        </div>

                        {setlang === "en" ? 
                        <div className="c-summary-row muted">
                          <span>Shipping</span>
                          <span>IRT {new Number(item.shipping_rate).toLocaleString()}</span>
                        </div> :
                        <div className="c-summary-row muted">
                          <span>{toPersiDigits(new Number(item.shipping_rate).toLocaleString())}</span>
                          <span>ارسال پستی (تومان)</span>
                        </div>
                        }

                      </div>
                  )))}

                  {setlang === "en" ? 
                  <div className="c-summary-total">
                    <span>Total</span>
                    <span className="c-total-amount">IRT {new Number(cart.total).toLocaleString()}</span>
                  </div> :
                  <div className="c-summary-total">
                    <span className="c-total-amount">تومان {toPersiDigits(new Number(cart.total).toLocaleString())}</span>
                    <span>جمع کل خرید</span>
                  </div>
                  }
                </div>
              ))}
              <Link to={`/${setlang}/cart`}>
                <button className="c-modal-button">{setlang === "en" ? "Update Cart" : "ویرایش سبد خرید" }</button> 
              </Link>
              <div className='c-divider'></div>
              
              <h2>{setlang === "en" ? "Delivery Information" : "آدرس پستی" }</h2>
              <div className={setlang === "en" ? "c-user-info": "c-user-info-fa"}>
                <p>{profile.first_name} {profile.last_name}</p>
                <p>{profile.address}, {profile.city} - {profile.zipcode}, {profile.province}, {profile.country}</p>
                <p>{profile.email} :{setlang === "en" ? "E-mail" : "ایمیل"}</p>
                <p>{profile.phone} :{setlang === "en" ? "Contact": "شماره تماس" }</p>
                <button className="c-modal-button" onClick={openModal}>{setlang === "en" ? "Edit Info" : "ویرایش آدرس "} </button>
              </div>
              <div className='c-divider'></div>

              <h2>{setlang === "en" ? "Account Information" : "کیف پول" }</h2>
              {infoCredit && (
                setlang === "en" ?
                  <div className="c-summary-row muted">
                    <span>Your available credit</span>
                    <span>IRT {new Number(infoCredit.amount_available_IRT).toLocaleString()}</span>
                  </div> :
                  <div className="c-summary-row muted">
                    <span>{toPersiDigits(new Number(infoCredit.amount_available_IRT).toLocaleString())}</span>
                    <span>موجودی قابل استفاده در حساب (تومان)</span>
                  </div>
              )}
              {setlang === "en" ?
                <div className="c-summary-row muted">
                  <span>Cart Total</span>
                  <span>IRT {new Number(cartValue).toLocaleString()}</span>
                </div> :
                <div className="c-summary-row">
                  <span>{toPersiDigits(new Number(cartValue).toLocaleString())} تومان</span>
                  <span> جمع کل خرید</span>
                </div>
              }
              <div className='c-divider'></div>
              <button className="c-modal-button" onClick={handlePurchase} >{setlang === "en" ? "Purchase" : "ثبت سفارش" }</button>
            </div>
          </div>
        </main>


        {isModalOpen && (
        <div onClick={handleOverlayClick} className="modal-overlay" type='submit'> 
          <div className={setlang === "en" ? "c-modal-container" : "c-modal-container-fa"} onClick={e => e.stopPropagation()}>
            <h1>{setlang === "en" ? "Delivery Information" : "آدرس پستی"}</h1>
            <p>{setlang === "en" ? "Verify delivery information" : "لطفا درستی آدرس پستی گیرنده را تایید کنید" }</p>
            <form>
              <div>
                <label>{setlang === "en" ? "First Name" : "نام" }</label>
                <input type="text" name="first_name" value={updatedProfile.first_name || ""} onChange={handleChange} placeholder={setlang === "en" ? "Enter first name" : "نام گیرنده را وارد کنید"} />
              </div>
              <div>
                <label>{setlang === "en" ? "Last Name" : "نام خانوادگی"}</label>
                <input type="text" name="last_name" value={updatedProfile.last_name || ""} onChange={handleChange} placeholder={setlang === "en" ? "Enter last name" : "نام خانوادگی گیرنده را وارد کنید"}/>
              </div>
              <div>
                <label>{setlang === "en" ? "Email" : "ایمیل"}</label>
                <input type="text" name="email" value={updatedProfile.email || ""} onChange={handleChange} placeholder={setlang === "en" ? "Enter email-address" : "ایمیل گیرنده را وارد کنید"}/>
              </div>
              <div>
                <label>{setlang === "en" ? "Contact No." : "شماره تماس"}</label>
                <input type="text" name="phone" value={updatedProfile.phone || ""} onChange={handleChange} placeholder={setlang === "en" ? "Enter contact phone/mobile number" : "شماره تماس گیرنده را وارد کنید"}/>
              </div>
              <div>
                <label>{setlang === "en" ? "City" : "نام شهر یا منطقه"}</label>
                <input type="text" name="city" value={updatedProfile.city || ""} onChange={handleChange} placeholder={setlang === "en" ? "Enter name of city/town" : "نام شهر/منطقه گیرنده را وارد کنید" }/>
              </div>
              <div>
                <label>{setlang === "en" ? "Province" : "استان"}</label>
                <input type="text" name="province" value={updatedProfile.province || ""} onChange={handleChange} placeholder={setlang === "en" ? "Enter province/state" : "استان گیرنده را وارد کنید"}/>
              </div>
              <div>
                <label>{setlang === "en" ? "Country" : "کشور" }</label>
                <input type="text" name="country" value={updatedProfile.country || ""} onChange={handleChange} placeholder={setlang === "en" ? "Enter country" : "کشور گیرنده"}/>
              </div>
              <div>
                <label>{setlang === "en" ? "Zipcode" : "کد پستی" }</label>
                <input type="text" name="zipcode" value={updatedProfile.zipcode || ""} onChange={handleChange} placeholder={setlang === "en" ? "Enter zipcode" : "کد پستی گیرنده را وارد کنید"}/>
              </div>
              <div>
                <div><label>{setlang === "en" ? "Address" : "آدرس" }</label></div>
                <input type="text" name="address" value={updatedProfile.address || ""} onChange={handleChange} placeholder={setlang === "en" ?"Enter street, house no." : "آدرس گیرنده را وارد کنید"}/>
              </div>

            </form>
              <div className="c-modal-actions">
                <button onClick={handleCancel} className="c-modal-button" >{setlang === "en" ? "Cancel" : "لغو"}</button>
                <button onClick={handleSaveprofile} type="submit" className="c-modal-button">{setlang === "en" ? "Submit" : "ذخیره" }</button>
              </div>
            {error && <p style={{color: "red"}}>{error}</p>}
          </div>
        </div>
        )}

        {payModal && (
        <div onClick={handleOverlayClick} className="modal-overlay" type='submit'> 
          <div className={setlang === "en" ? "c-modal-container" : "c-modal-container-fa"} onClick={e => e.stopPropagation()}>
            <h1>{setlang === "en" ? "Payment Information" : "موجودی کیف پول" }</h1>
            <p>{setlang === "en" ? "Account balance insufficient" : ".موجودی کیف پول شما کافی نمی‌باشد"}</p>
            <div className='divider'></div>

            {infoCredit && (
              setlang === "en" ? 
                <div className='modal-summary-row muted'>
                  <span>Available credit:</span>
                  <span>IRT {new Number(infoCredit.amount_available_IRT).toLocaleString()}</span>
                </div> :
                <div className='modal-summary-row muted'>
                  <span>{toPersiDigits(new Number(infoCredit.amount_available_IRT).toLocaleString())}</span>
                  <span> (تومان) موجودی قابل استفاده</span>
                </div>
            )}

            {setlang === "en" ? 
              <div className='modal-summary-row muted'>
                <span>Cart value:</span>
                <span>IRT {new Number(cartValue).toLocaleString()}</span>
              </div> :
              <div className='modal-summary-row muted'>
                <span>{toPersiDigits(new Number(cartValue).toLocaleString())}</span>
                <span> (تومان)ارزش کل خرید</span>
              </div>
            }

            <div className='modal-minidivider'></div>

            {setlang === "en" ? 
              <div className='modal-summary-row'>
                  <span>Remaining</span>
                  <span>IRT {new Number(defiCred).toLocaleString()}</span>
              </div> :
              <div className='modal-summary-row'>
                  <span>{toPersiDigits(new Number(defiCred).toLocaleString())}</span>
                  <span>باقی مانده (تومان)</span>
              </div>
            }

            <div className="c-modal-actions">
              <button onClick={handleCancel} className="c-modal-button" >{setlang === "en" ? "Cancel" : "لغو" }</button>
              <Link to={`/${setlang}/profile/account/${4682}`}>
                <button type="submit" className="c-modal-button">{setlang === "en" ? "Add Credit" : "افزایش موجودی"}</button>
              </Link>
            </div>
          </div>
        </div>
        )}
      </div>
    <Footer/>
    </>
  );
};

export default CheckoutPage;
